<script setup></script>

<template>
	<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="var(--data__common_behind_color);" style="width: 20px">
		<path
			d="
    M9.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0
    M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0
    M9.5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0
  "
		/>
	</svg>
</template>
<style></style>
